module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.128/js/sprocket_orange.svg"